import { useQuery } from "@tanstack/react-query";
import { apiClient, buildQueryParams } from "@finitless/shared/lib";
import { isEndpointEnabled } from "@finitless/shared/config";
import { buildBusinessWhereClause } from "@finitless/shared/hooks";

export const useBusinessesForIntegrations = (params = {}) => {
  const {
    enabledFilter = "all",
    searchTerm = "",
    page = 1,
    pageSize = 10,
  } = params;

  const whereClause = buildBusinessWhereClause(enabledFilter, searchTerm);

  const queryParams = {
    params: "name,slug,logo,third_party_integrations",
    where: whereClause,
    page,
    page_size: pageSize,
  };

  const queryString = buildQueryParams(queryParams);

  return useQuery({
    queryKey: [
      "businesses-integrations",
      enabledFilter,
      searchTerm,
      page,
      pageSize,
    ],
    queryFn: async () => {
      const response = await apiClient.get(
        `/backoffice/businesses${queryString ? `?${queryString}` : ""}`,
      );
      return {
        businesses: response?.result || [],
        pagination: response?.pagination || {},
      };
    },
    enabled: isEndpointEnabled("business", "list"),
    staleTime: 5 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
